<div id="welcome-page-wrap" *ngIf="active">
    <div id="welcome-page-background">
      <div class="welcome-page-content">
        <div class="keen-slider align-items-end" #sliderRef>
          <div *ngFor="let s of additionalSlides; let index = index" class="keen-slider__slide number-slide{{index + 3}}">
            <div class="feature-banner image-only">
              <div class="welcome-page-close white" (click)="close()">
                <i class="fa fa-close"></i>
              </div>

              <div class="welcome-page-full-img">
                <a
                  [href]="s.href"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="banner-link"
                >
                  <img
                    [src]="s.screenshotImage"
                    [alt]="'main_guide_feature_image_alt' | translate"
                  >
                </a>
              </div>

              <div class="banner-checkbox">
                <input type="checkbox" [(ngModel)]="dontShowAgain">
                <span>{{ 'dont_show_this_again' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div *ngIf="additionalSlides.length > 1" [class]="'dots ' + ('dots-' + (currentSlide + 1))">
          <button
            (click)="slider.moveToIdx(i)"
            *ngFor="let slide of dotHelper; let i = index"
            [class]="'dot ' + (i === currentSlide ? 'active' : '')"
          ></button>
        </div>
      </div>
    </div>
</div>
